import * as React from 'react';
import { useSelector } from 'react-redux';

import { Avatar } from '../../../components/Avatar';
import { getAnswerById } from '../../../selectors/answers';

interface IAvatarContainerProps {
  answerId: string;
}

export function AvatarContainer({ answerId }: IAvatarContainerProps): React.JSX.Element {
  const { user } = useSelector(getAnswerById(answerId));

  return <Avatar avatarUrl={user.avatarUrl} type={user.type} />;
}
